import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'

Vue.component('qrcode', VueQrcode)
